import { getCosH5Address, LANG, isNikke, isPubgm, CLIENT_TYPE, getUrlParameter, getUaInfoString } from "@/constant";
import pwaURL from "@/assets/menu-assets/images/pwa-ios.png";
import { postApiRtt } from "@/util/performance";
import i18n from "@/i18n";
import { addToPwa } from "@/util/pwa";
import { showDefaultDialog } from "@/util/cloudgame/cg-error-handler";

export function nowDateTime(time = false) {
  const date = new Date();
  if (time) {
    return date.getTime();
  }
  return `${date.getFullYear()}-${fn(date.getMonth() + 1)}-${fn(
    date.getDate()
  )} ${fn(date.getHours())}:${fn(date.getMinutes())}:${fn(date.getSeconds())}`;
}

export function secondToMs(sec) {
  return sec * 1000;
}
export function minToMs(min) {
  return secondToMs(min * 60);
}
export function countTargetTime(time) {
  return noDateTimeSecond() + time;
}
export function isReachTarget(targetTime) {
  return noDateTimeSecond() >= targetTime;
}
export function countLeftTime(targetTime) {
  return targetTime - noDateTimeSecond();
}

export function noDateTimeSecond() {
  return Math.round(nowDateTime(true) / 1000) * 1000;
}

// 重启游戏，不换设备
export async function restartGame() {
  // await window.cg.game.freeDevice();
  // await window.cg.game.quitGame();
  // setTimeout(() => {
  //   window.location.reload();
  // }, 2000);
  window.cg.message.sendSocketChannelData({
    cmd: "CMD_RESTART_GAME",
    androidEvent: {
      cmd: "CMD_RESTART_GAME",
    },
  });
}

// 重启游戏，切换语言【消息】
function sendRestartMsg() {
  window.cg.message.sendSocketChannelData({
    cmd: "CMD_FORCE_RESTART_GAME",
    data: {
      customLanguage: i18n.t("customLanguage"),
      customCountry: i18n.t("customCountry"),
      customLocaleChange: true,
      webUA: getUaInfoString(),
      timeZoneID: Intl.DateTimeFormat().resolvedOptions().timeZone ?? "",
      webTimeOffset: new Date().getTimezoneOffset().toString() ?? "",
      webHttpLanguage: window.navigator.languages.toString().slice(0,90),
      webLocaleLanguage: window.navigator.language,
    }
  });
  // cg_clicked代表是否发送过重启指令，设备不变时不会重复发送，设备变化时会清空该值
  localStorage.setItem("cg_clicked", true);
}

// 重启游戏，切换语言，结合开关逻辑
export async function resetLang(obj) {
  if (!(isPubgm() || isNikke()) || localStorage.getItem("cg_clicked")) {
    return;
  }
  // nikke情况下，有开关控制是否需要重启
  if (isNikke()) {
    const needRestart = getParamType("startype");
    console.log("needRestart", needRestart);
    if (needRestart) {
      sendRestartMsg();
      // nikke重启等待时增加loadingtxt
      obj.$loadingTxt.open();
    }
    return;
  }
  sendRestartMsg();
}

let lastClickTime = 0;
function preventDoubleClick(e) {
  const timeNow = Date.now();
  if (timeNow - lastClickTime < 300) { // 300毫秒内的点击被认为是快速双击
    // 阻止快速双击事件
    e.preventDefault();
    e.stopImmediatePropagation();
    console.log("fast click");
  }
  lastClickTime = timeNow;
}

function preventZoom(e) {
  if (e.touches.length > 1) {  // 只有当检测到多于一个触点时才阻止默认行为
    e.preventDefault();
    e.stopPropagation();
  }
}

function preventEvent(e) {
  e.preventDefault();
}

//禁用手势
export function ForbiddH5Drag() {
  document.addEventListener('touchstart', preventZoom, { passive: false });
  document.addEventListener('touchmove', preventZoom, { passive: false });
  document.addEventListener('touchend', preventZoom, { passive: false });
  document.addEventListener('touchcancel', preventZoom, { passive: false });
  document.addEventListener('dblclick', preventEvent, { passive: false });
  document.addEventListener('click', preventDoubleClick, { passive: false });
  document.addEventListener('contextmenu', preventEvent, { passive: false });
}

//移除禁用手势缩放监听
export function removeForbiddH5Drag() {
  document.removeEventListener('touchstart', preventZoom, { passive: false });
  document.removeEventListener('touchmove', preventZoom, { passive: false });
  document.removeEventListener('touchend', preventZoom, { passive: false });
  document.removeEventListener('touchcancel', preventZoom, { passive: false });
  document.removeEventListener('dblclick', preventEvent, { passive: false });
  document.removeEventListener('click', preventDoubleClick, { passive: false });
  document.removeEventListener('contextmenu', preventEvent, { passive: false });
}

// 监听是否回来
export function watchComeback(_this) {
  if (isPubgm()) {
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible') {
        _this.$dialogBox({
          content: _this.$t("error.welcomeBack").toString(),
          confirm: "OK",
          needForceLandscape: _this.needForceLandscape,
          gameId: _this.gameId,
        });
      }
    });
    return;
  }
  // 残局
  if (_this.gameType == 1) {
    document.addEventListener('visibilitychange', function() {
      if (document.visibilityState === 'visible') {
        // 老容器, 且点击开始后，才触发cg_start: false, 且游戏未结束
        if (localStorage.getItem("cg_start") && localStorage.getItem("cg_start") == "false"
          && localStorage.getItem("cg_clicked") && _this.gameEnded != true) {
            window.cg.game.freeDevice();
            window.cg.game.quitGame();
            showDefaultDialog();
        }
      }
    });
    return;
  }
}

/**
 * 目前仅可能获取真实clientWidth的方法较为hacky。
 * 其实最简单的处理方式是直接使用document.documentElement.clientWidth，
 * 但该种方式无法考虑到如Safari for iOS信息栏的隐藏，因此需要借助于window.innerWidth；
 * 但是，window.innerWidth有时会不准，远超过实际尺寸，因此多加一个判断：
 * 当window.innerWidth大于document.documentElement.clientWidth
 * 的1.5倍时，仍采用document.documentElement.clientWidth
 * 因为document.documentElement.clientWidth在旋转时，切换的速度较慢，所以再加一层逻辑，竖屏时取小，横屏时取大
 */
export function actualClientWidth() {
  if (window.orientation === 0 || window.orientation === 180) {
    return Math.min(
      document.documentElement.clientWidth || 0,
      (window.innerWidth || 0) > (document.documentElement.clientWidth || 0) * 1.5 ? 0 : window.innerWidth
    );
  } else {
    return Math.max(
      document.documentElement.clientWidth || 0,
      (window.innerWidth || 0) > (document.documentElement.clientWidth || 0) * 1.5 ? 0 : window.innerWidth
    );
  }
}

/**
 * 目前仅可能获取真实clientHeight的方法较为hacky。
 * 其实最简单的处理方式是直接使用document.documentElement.clientHeight，
 * 但该种方式无法考虑到如Safari for iOS信息栏的隐藏，因此需要借助于window.innerHeight；
 * 但是，window.innerHeight有时会不准，远超过实际尺寸，因此多加一个判断：
 * 当window.innerHeight大于document.documentElement.clientHeight
 * 的1.5倍时，仍采用document.documentElement.clientHeight
 */
export function actualClientHeight() {
  if (window.orientation === 0 || window.orientation === 180) {
    return Math.max(
      document.documentElement.clientHeight || 0,
      (window.innerHeight || 0) > (document.documentElement.clientHeight || 0) * 1.5 ? 0 : window.innerHeight
    );
  } else {
    return Math.min(
      document.documentElement.clientHeight || 0,
      (window.innerHeight || 0) > (document.documentElement.clientHeight || 0) * 1.5 ? 0 : window.innerHeight
    );
  }
}

/**
 * 切换账号
 * 逻辑：删除当前的cookies，然后重启设备
 */
export function switchAccount(gameid) {
  // 删除账号的token cookies，保证下次进入时重新获取新的token
  // window.localStorage.setItem("cg_token", "");
  const thirdLoginInfo = JSON.parse(window.localStorage.getItem("third_login_info") || "{}");
  thirdLoginInfo[gameid] = "";
  window.localStorage.setItem("third_login_info", JSON.stringify(thirdLoginInfo));
  // 重启游戏，申请新的设备
  restartGame();
}

export function onCloudGameReady (cb) {
  if (window.cg) {
      cb();
      return;
  }
  readyCallbackFunctions.push(cb);
  if (!readyCallbackTimer) {
      createReadyTimer();
  }
}

function isIphoneSafari() {
  let ua = window.navigator.userAgent;
  let isIphone = !!ua.match(/iPhone/i);
  let webkit = !!ua.match(/WebKit/i);
  let isSafari = /^((?!chrome|android).)*safari/i.test(ua); // Additional check
  let result = isIphone && webkit && !ua.match(/CriOS/i) && isSafari;
  return result;
};

export function showDownloadBox(idx, gameId, that, scene) {
  getCosH5Address(`download-box-${LANG}-${idx}`, gameId).then(
    (data) => {
      that.$downloadBox({ imageUrl: data }).then((data) => {
        if (data == "confirm") {
          // 处理下载
          console.log("跳转下载");
          postParentMsg("download", scene);
          // window.parent.postMessage({ type: "download", data: 1 }, "*");
        }
        if (data == "cancel") {
          console.log("取消下载")
          handleAddPwa("cancelDownlaod", that);
        }
      });;
    }
  );
  switch (idx) {
    case 0:
      postApiRtt("popup_email");
      break;
    case 1:
      postApiRtt("popup_pay");
      break;
    case 5:
      postApiRtt("popup_old_user");
      break;
  }
}

export function handleAddPwa(data, that) {
  if (getUrlParameter(window.location.search, "channel") == "pwa") {
    return;
  }
  if (!isIphoneSafari()) {
    if (window == window.parent) {
      addToPwa();
    } else {
      postParentMsg("pwa", data);
    }
  } else {
    const gameId = window.location.pathname.split('/').slice(-1)[0];
    getCosH5Address(`pwa-${LANG}`, gameId).then(
      (url) => {
        that.$downloadBox({
          imageUrl: url, needHide: true, type: data,
          needForceLandscape: that.needForceLandscape
        }).then();
      }
    );
    postApiRtt("pwa_popup_impression_ios");
  }
}

export function postParentMsg(type, data) {
  window.parent.postMessage(
    {
      type: type,
      data: data,
      from: "cloudgame",
      user: {
        openid: localStorage.getItem("cg_openid") ?? ""
      }
    },
    "*"
  );
  if (type == "download") {
    postApiRtt(`download_${data}`);
  }
}

// event1 曝光， event2 confirm，event3 cancel
export function showSystemDownloadBox(that, content, event1, event2, event3) {
  that.$dialogBox({
    content: content.toString(),
    confirm: that.$t("menu.download").toString(),
    cancel: that.$t("queue.cancelbtn").toString(),
    // width: 320,
    showCloseBtn: false,
    needForceLandscape: that.needForceLandscape,
    textAlign: "center",
    gameId: that.gameId,
  })
  .then((data) => {
    if (data == "confirm") {
      gotoDownloadUrl(that);
      postApiRtt(event2);
    } else if (data == "cancel") {
      handleAddPwa("", that);
      postApiRtt(event3);
    }
  });
  postApiRtt(event1);
}

export function gotoDownloadUrl(that) {
  const urlInfo = {
    "ios": "https://app.adjust.com/1idvcq99_1i4mzl48?deep_link=igame1320%3A%2F%2F",
    "android": "https://web.gpubgm.com/m/Website/xiaobao/PUBGMOBILE_Global_3.5.0_cloudyun_07CC13FF3A.apk"
  }
  const url = urlInfo[CLIENT_TYPE];
  window.location.href = url;
}

export function showFaceDownloadBox(that) {
  getCosH5Address(`download-box-${LANG}`, that.gameId).then(
    (data) => {
      that.$downloadBox({
        imageUrl: data,
        needForceLandscape: true,
        showCloseBtn: true
      }).then((data) => {
        if (data == "confirm") {
          gotoDownloadUrl(that);
          postApiRtt("download_activity_btn_click");
        }
        if (data == "cancel") {
          that.needForceLandscape = true;
          handleAddPwa("", that);
          postApiRtt("downloadactivity_close_click");
        }
      });;
    }
  );
  postApiRtt("downloadactivity_impression");
}

let totalSeconds = 0;
let intervalId = null;

// 检测用户在线时长
export function startTracking(that) {
  console.log("tracking!!!")
  // 检查今天是否已经开始跟踪
  const today = new Date().toISOString().slice(0, 10); // 获取当前日期，格式为 YYYY-MM-DD
  const storedDate = localStorage.getItem('cg_track_date');
  const storedSeconds = parseInt(localStorage.getItem('cg_tracked_sec'), 10);
  if (storedDate === today && storedSeconds) {
    totalSeconds = storedSeconds;
  } else {
    totalSeconds = 0;
    localStorage.setItem('cg_track_date', today);
    localStorage.setItem('cg_tracked_sec', 0);
    // 移除今日已弹过标识
    localStorage.removeItem("cg_popup");
  }
  if (intervalId) {
    return;
  }
  intervalId = setInterval(() => {
    // 未登录不计算
    if (localStorage.getItem("cg_openid") && localStorage.getItem("cg_last_login")) {
      totalSeconds += 1;
      localStorage.setItem('cg_tracked_sec', totalSeconds.toString());
      handleGameTime(totalSeconds, that);
    }
  }, 1000);
}

function handleGameTime(time, that) {
  // 检查是否弹过
  if (localStorage.getItem("cg_popup")) {
    return;
  }
  const isNeedWait = that.$store.state.cloudgame.isInGame;
  // 检查是否在游戏中
  if (isNeedWait) {
    return;
  }
  // 到了10分钟
  if (time >= 600) {
    showFaceDownloadBox(that);
    localStorage.setItem("cg_popup", true);
  }
  // clearInterval(intervalId);  // 停止计时
  // localStorage.removeItem('cg_tracked_sec'); // 重置秒数
}

export function copyText(text, _this) {
  let copyInput = document.getElementById('_copyInput_');
  if (!copyInput) {
      copyInput = document.createElement('input');
      copyInput.setAttribute('type', 'text');
      copyInput.setAttribute('style', 'height:10px;position:fixed;top:-100px;opacity:0;');
      copyInput.setAttribute('id', '_copyInput_');
      document.body.appendChild(copyInput);
  }
  copyInput.value = text;
  copyInput.select();
  const result = document.execCommand('Copy');
  if (!result) {
      console.warn('复制失败');
  }
  copyInput.blur();
  _this.$toast.open("Link copied");
  return result;
}

export function getParamType(param) {
  return getUrlParameter(window.location.search, param);
}
